import { useAuthStore } from "../store/authStore";

/**
 * Hooks selectivos sobre el `useAuthStore` de Zustand. Cada uno se suscribe
 * a un slice mínimo del state para evitar re-renders innecesarios.
 *
 * Reglas de uso:
 *  - `useCurrentUser` / `useIsAuthenticated` / `useIsAuthLoading` para LECTURAS.
 *  - `useLogin` / `useLogout` / `useCheckAuth` para ACCIONES (estables).
 *
 * Ejemplo:
 *   const login = useLogin();
 *   const isAuthenticated = useIsAuthenticated();
 *   await login(email, password);
 */

/** Solo lee el user. Re-render solo cuando cambia el user. */
export function useCurrentUser() {
	return useAuthStore((s) => s.user);
}

/** Re-render solo cuando cambia el flag de autenticación. */
export function useIsAuthenticated() {
	return useAuthStore((s) => s.isAuthenticated);
}

/** Re-render solo cuando cambia el flag de loading (importante para gates de ruta). */
export function useIsAuthLoading() {
	return useAuthStore((s) => s.isLoading);
}

/** Acción: login. Estable, no causa re-renders. */
export function useLogin() {
	return useAuthStore((s) => s.login);
}

/** Acción: logout. Estable, no causa re-renders. */
export function useLogout() {
	return useAuthStore((s) => s.logout);
}

/** Acción: checkAuth (rerifica sesión en mount). Estable, no causa re-renders. */
export function useCheckAuth() {
	return useAuthStore((s) => s.checkAuth);
}

/** Acción: changePassword. Estable, no causa re-renders. */
export function useChangePassword() {
	return useAuthStore((s) => s.changePassword);
}